import { Host, h } from '@stencil/core';
export class AibaDonut {
  constructor() {
    this.handleClickDonut = (event) => {
      this.handleClick(event);
    };
    this.setDonutSize = () => {
      this.progressCircleRef.style.width = `${this.size}px`;
      this.progressCircleRef.style.height = `${this.size}px`;
      this.first50Ref.style.width = `${this.size}px`;
      this.first50Ref.style.height = `${this.size}px`;
      this.valueBarRef.style.width = `${this.size}px`;
      this.valueBarRef.style.height = `${this.size}px`;
      const adjustedSize = this.size - this.borderWidth * 2;
      this.innerRef.style.width = `${adjustedSize}px`;
      this.innerRef.style.height = `${adjustedSize}px`;
      this.innerRef.style.margin = `${this.borderWidth}px`;
    };
    this.setColors = () => {
      this.progressCircleRef.style.height = `${this.size}px`;
      this.progressCircleRef.style.backgroundColor = `${this === null || this === void 0 ? void 0 : this.backgroundColor}`;
      this.progressCircleRef.style.boxShadow = `inset 0 0 0 ${this === null || this === void 0 ? void 0 : this.boxShadowWidth} ${this === null || this === void 0 ? void 0 : this.backgroundColor}`;
      this.first50Ref.style.borderColor = `${this === null || this === void 0 ? void 0 : this.borderColor}`;
      this.first50Ref.style.backgroundColor = `${this === null || this === void 0 ? void 0 : this.borderColor}`;
      this.valueBarRef.style.borderColor = `${this === null || this === void 0 ? void 0 : this.borderColor}`;
      this.valueBarRef.style.backgroundColor = `${this === null || this === void 0 ? void 0 : this.borderColor}`;
      this.innerRef.style.borderColor = `${this === null || this === void 0 ? void 0 : this.backgroundColor}`;
      this.innerRef.style.backgroundColor = `${this === null || this === void 0 ? void 0 : this.backgroundColor}`;
      this.innerRef.style.color = `${this === null || this === void 0 ? void 0 : this.borderColor}`;
    };
    this.componentDidLoad = async () => {
      this.setDonutSize();
      this.valueBarRef.style.transform = `rotate(${Number(this.value) * 3.6}deg)`;
      this.first50Ref.style.display = Number(this.value) < 50 ? 'none' : 'block';
      this.leftHalfClipperRef.style.position = Number(this.value) < 50 ? 'absolute' : 'initial';
      if (Number(this.value) < 50) {
        this.leftHalfClipperRef.style.width = 'auto';
      }
      this.leftHalfClipperRef.style.clip = Number(this.value) < 50 ? `rect(0px, ${this.size}px, ${this.size}px, ${this.size / 2}px)` : '';
      this.first50Ref.style.clip = `rect(0px, ${this.size}px, ${this.size}px, ${this.size / 2}px)`;
      this.valueBarRef.style.clip = `rect(0px, ${this.size / 2}px, ${this.size}px, 0px)`;
      if (this.boxShadowWidth && this.borderColor && this.backgroundColor)
        this.setColors();
      const handleClickDonutRef = this.handleClickDonut;
      this.donutParentRef &&
        this.donutParentRef.addEventListener('keydown', async function (event) {
          if (event.key === 'Enter') {
            handleClickDonutRef(event);
          }
        });
    };
    this.value = 35;
    this.class = '';
    this.size = 136;
    this.data = undefined;
    this.content = undefined;
    this.boxShadowWidth = undefined;
    this.borderColor = undefined;
    this.backgroundColor = undefined;
    this.variant = 'low';
    this.borderWidth = 10;
    this.active = undefined;
    this.styles = undefined;
    this.classes = undefined;
    this.renderForModal = undefined;
    this.handleClick = undefined;
  }
  render() {
    var _a;
    if (typeof this.data === 'string') {
      if (this.data)
        this.data = JSON.parse(this.data);
    }
    return (h(Host, null, this.styles && h("style", null, this.styles), h("div", { class: `donut-wrapper ${this.class}`, tabIndex: this.handleClick ? 0 : null, role: this.handleClick ? 'button' : '', onClick: (event) => this.handleClickDonut && this.handleClickDonut(event), ref: el => (this.donutParentRef = el) }, this.data &&
      ((_a = this.data.elements) === null || _a === void 0 ? void 0 : _a.map((element) => {
        var _a, _b, _c, _d;
        if (element && element['name'] === 'aiba-label' && element['tag'] === 'title' && !this.renderForModal)
          return (h("div", { class: "donut-heading" }, h("aiba-label", Object.assign({}, element['data'], { text: ((_a = this.content) === null || _a === void 0 ? void 0 : _a.heading) ? this.content.heading : element['data']['text'] }))));
        if (element && element['name'] === 'aiba-label' && element['tag'] === 'circle')
          return (h("div", { class: `progress-circle ${this.variant ? this.variant : ''}`, ref: el => (this.progressCircleRef = el) }, h("div", { class: `inner-circle ${this.variant ? this.variant : ''}`, ref: el => (this.innerRef = el) }, h("aiba-label", Object.assign({}, element['data'], { text: ((_b = this.content) === null || _b === void 0 ? void 0 : _b.text) ? this.content.text : element['data']['text'] }))), h("div", { class: `left-half-clipper ${this.variant ? this.variant : ''}`, ref: el => (this.leftHalfClipperRef = el) }, h("div", { class: `first50-bar new ${this.variant ? this.variant : ''}`, ref: el => (this.first50Ref = el) }), h("div", { class: `value-bar ${this.variant ? this.variant : ''}`, ref: el => (this.valueBarRef = el) })), element['heading'] && (h("div", { class: `donut-circle-heading` }, h("p", null, element === null || element === void 0 ? void 0 : element.headingText)))));
        if (element && element['name'] === 'aiba-link' && !this.renderForModal)
          return h("aiba-link", Object.assign({}, element['data'], { text: ((_c = this.content) === null || _c === void 0 ? void 0 : _c.name) ? this.content.name : element['data']['text'] }));
        if (element && element['name'] === 'aiba-label' && element['_id'] === 'subheading')
          return h("aiba-label", Object.assign({}, element['data'], { text: ((_d = this.content) === null || _d === void 0 ? void 0 : _d.name) ? this.content.name : element['data']['text'] }));
      })), h("slot", null))));
  }
  static get is() { return "aiba-donut"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-donut.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-donut.css"]
    };
  }
  static get properties() {
    return {
      "value": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "value",
        "reflect": false,
        "defaultValue": "35"
      },
      "class": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "class",
        "reflect": false,
        "defaultValue": "''"
      },
      "size": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "size",
        "reflect": false,
        "defaultValue": "136"
      },
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "content": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "content",
        "reflect": false
      },
      "boxShadowWidth": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "box-shadow-width",
        "reflect": false
      },
      "borderColor": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "border-color",
        "reflect": false
      },
      "backgroundColor": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "background-color",
        "reflect": false
      },
      "variant": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'low' | 'high' | 'medium'",
          "resolved": "\"high\" | \"low\" | \"medium\"",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "variant",
        "reflect": false,
        "defaultValue": "'low'"
      },
      "borderWidth": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "border-width",
        "reflect": false,
        "defaultValue": "10"
      },
      "active": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "active",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "renderForModal": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "render-for-modal",
        "reflect": false
      },
      "handleClick": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handle-click",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=aiba-donut.js.map
